import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import Input from 'antd/lib/input';
import '../normalsearch.css';
import { postAreYouLookingForSomeThingElse } from '../../HttpRequest/issues';
import { registersuccess } from '../../SweetAlert/SweetAlert';


const AreYouLookingForSomeThingElse = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { handleSubmit, control, reset } = useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    reset();
    setIsModalVisible(false);
  };

  const onSubmit = (data) => {
    const formData = {
        category: 'looking for something else',
          status:'OPEN',
          userId: localStorage.getItem("id"),
        ...data
    }
    console.log('Form data:', formData);
    postAreYouLookingForSomeThingElse(formData).then((response)=>{
        if(response.request.status == 201 ){
        reset();
        setIsModalVisible(false);
        registersuccess("Request was successfull");
        console.log("data sucess");
        } else {
        console.log("data error")
        }
    });
  };

  return (
    <div>
      <Button
        style={{
          background: '#3F5FD6',
          color: 'white',
        }}
        onClick={showModal}
      >
        Are you looking for something else?
      </Button>
      <Modal
        title="Are you looking for something else"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="country"
            control={control}
            rules={{ required: 'Please enter country' }}
            render={({ field, fieldState }) => (
              <div className="profileShortListingdiv">
                <label className="profileShortListingp">Country:</label>
                <Input {...field} />
                <span style={{ color: 'red' }}>{fieldState?.error?.message}</span>
              </div>
            )}
          />

          <Controller
            name="university"
            control={control}
            rules={{ required: 'Please enter University Name' }}
            render={({ field, fieldState }) => (
              <div className="profileShortListingdiv">
                <label className="profileShortListingp">University Name:</label>
                <Input {...field} />
                <span style={{ color: 'red' }}>{fieldState?.error?.message}</span>
              </div>
            )}
          />

          <Controller
            name="course"
            control={control}
            rules={{ required: 'Please enter Program Name' }}
            render={({ field, fieldState }) => (
              <div className="profileShortListingdiv">
                <label className="profileShortListingp">Program Name:</label>
                <Input {...field} />
                <span style={{ color: 'red' }}>{fieldState?.error?.message}</span>
              </div>
            )}
          />

          <Controller
            name="comment"
            control={control}
            render={({ field }) => (
              <div className="profileShortListingdiv">
                <label className="profileShortListingp">Any other information:</label>
                <Input.TextArea rows={4} {...field} />
              </div>
            )}
          />
          <div className='d-flex' style={{justifyContent: 'end'}}>
            <div>
            </div>
            <div>
            <Button
            style={{
              background: '#3F5FD6',
              color: 'white',
            }}
            htmlType="submit"
          >
            Submit
          </Button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default AreYouLookingForSomeThingElse;
